import {
  GET_ALL_EVENT_GROUPS,
  GET_ALL_EVENT_GROUPS_SUCCESS,
  GET_ALL_EVENT_GROUPS_FAILURE,
} from "./actionTypes";

export const getAllEventGroups = (payload) => {
  return {
    type: GET_ALL_EVENT_GROUPS,
    payload: payload,
  };
};

export const getAllEventGroupsSuccess = (payload) => {
  return {
    type: GET_ALL_EVENT_GROUPS_SUCCESS,
    payload: payload,
  };
};

export const getAllEventGroupsFailure = (error) => {
  return {
    type: GET_ALL_EVENT_GROUPS_FAILURE,
    payload: error,
  };
};
